import {createAsyncThunk, createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../../store';
import IprojectData from '../../interfaces/projectData.interface';

// Define a type for the slice state
export interface ProjectsState {
    projects:IprojectData[];
    used_projects:IprojectData[];
    current_project?:IprojectData
}

// Define the initial state using that type
const initialState: ProjectsState = {
    projects: [],
    used_projects: [],
    current_project: undefined
}

export const fetchProjects = createAsyncThunk("projects/getAll", async()=>{
    const response = await fetch(process.env.REACT_APP_API_URI+"/projects",{
        method:"GET"
    });
    const data = response.json()
    return data;

});

export const fetchUsedProjects = createAsyncThunk("projects/getWithHistory", async()=>{
    const response = await fetch(process.env.REACT_APP_API_URI+"/projects/getWithHistory",{
        method:"GET"
    });
    const data = response.json()
    return data;

});


export const ProjectsSlice = createSlice({
  name: 'Projects',
  initialState,
  reducers: {
    setActiveProject: (state, {payload}:PayloadAction<IprojectData>)=>{
        if(payload.id){
            state.current_project = payload;
        }else{
            state.current_project = undefined;
        }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProjects.fulfilled, (state, {payload}:PayloadAction<IprojectData[]>) => {
        state.projects = payload;
    })
    builder.addCase(fetchUsedProjects.fulfilled, (state, {payload}:PayloadAction<IprojectData[]>) => {
        state.used_projects = payload;
    })
  }
});
    

export const {setActiveProject} = ProjectsSlice.actions


export default ProjectsSlice.reducer